import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { reportActionCreators } from '~/redux/ducks/playersAndTeams/report';
import { commonMessages } from '~/utility/commonMessages';

import SeasonFromSelect from '../seasonRangeSelect/components/SeasonFromSelect';
import SeasonToSelect from '../seasonRangeSelect/components/SeasonToSelect';

import { CalendarSelects } from './components';

import {
    DateControlsContainer,
    InlineLabel,
    InputSeparator,
    TimeControls,
    TimeSelectContainer,
    LabelledInputContainer,
    SumResultsContainer,
} from './styles';

const DateRangeSelect = () => {
    const dispatch = useDispatch();
    const isAggregate = useSelector((state) => state.playersAndTeams.report.current.isAggregate);
    const isDateRangeFromSeasons = useSelector((state) => state.playersAndTeams.report.current.isDateRangeFromSeasons);

    const setIsAggregate = (e) => {
        dispatch(reportActionCreators.setIsAggregate(e.target.checked));
        dispatch(reportActionCreators.runReport());
    };

    const setIsDateRangeFromSeason = (value) => {
        dispatch(reportActionCreators.setIsDateRangeFromSeason(value));
        dispatch(reportActionCreators.runReport());
    };

    const onRadioChange = (e) => {
        const isTrue = e.target.value === 'true';
        setIsDateRangeFromSeason(isTrue);
    };

    const TimeSelects = isDateRangeFromSeasons ? (
        <TimeSelectContainer>
            <SeasonFromSelect />
            <InputSeparator>-</InputSeparator>
            <SeasonToSelect />
        </TimeSelectContainer>
    ) : (
        <CalendarSelects />
    );

    return (
        <DateControlsContainer>
            <TimeControls>
                <LabelledInputContainer>
                    <input
                        type="radio"
                        name="isDateRange"
                        id="dateRangeSelect"
                        checked={!isDateRangeFromSeasons}
                        onChange={onRadioChange}
                        value="false"
                    />
                    <InlineLabel htmlFor="dateRangeSelect">
                        <FormattedMessage {...commonMessages.labels.dateRange} />
                    </InlineLabel>
                </LabelledInputContainer>
                <LabelledInputContainer>
                    <input
                        type="radio"
                        name="isDateRange"
                        id="seasonRangeSelect"
                        checked={isDateRangeFromSeasons}
                        onChange={onRadioChange}
                        value="true"
                    />
                    <InlineLabel htmlFor="seasonRangeSelect">
                        <FormattedMessage {...commonMessages.labels.seasonRange} />
                    </InlineLabel>
                </LabelledInputContainer>
                <SumResultsContainer>
                    <input
                        type="checkbox"
                        name="sumResults"
                        id="sumResults"
                        onChange={setIsAggregate}
                        checked={isAggregate}
                    />
                    <InlineLabel htmlFor="sumResults">
                        <FormattedMessage {...commonMessages.labels.sumResults} />
                    </InlineLabel>
                </SumResultsContainer>
            </TimeControls>
            {TimeSelects}
        </DateControlsContainer>
    );
};

export default DateRangeSelect;
